import { z } from 'zod'
import { PageNumberValidation } from '../../../../../../../_kernel/PageNumber'

export const GETLikesPropertiesQuery = z.object({
  limit: z.string(),
  page: z.string(),
})
export type GETLikesPropertiesResponseType = z.infer<typeof GETLikesPropertiesResponse>
export const GETLikesPropertiesResponse = z.object({
  pagination: z.object({
    total: PageNumberValidation.shape.value,
    last: PageNumberValidation.shape.value,
    page: PageNumberValidation.shape.value,
  }),
  properties: z
    .object({
      propertyId: z.number(),
    })
    .array(),
})
